import { Page, TaskCenter } from "@supplier/entity";
import httpRequest from "./index";
import { confirmable } from "@/utils/decorator/confirmable";

const PATH = "/task-center";

export const paging = async (params: unknown): Promise<Page<TaskCenter>> => {
    const { data } = await httpRequest.get(`${PATH}/paging`, { params });
    return data;
};

export const download = async (id: number | string | (number | string)[], name: string = "模板"): Promise<Blob> => {
    let path = `${PATH}/download/${id}`;
    if (Array.isArray(id)) {
        path = `${PATH}/download?ids=${id}`;
    }
    const data: Blob = await httpRequest.get(path, { responseType: "blob" });
    const url = window.URL.createObjectURL(data);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", name);
    document.body.appendChild(link);
    link.click();
    return data;
};

export const deleteAll = confirmable("是否删除所有任务中心历史记录")(async () => {
    await httpRequest.delete(`${PATH}/completed`);
});

export const deleteTask = async (id: number) => {
    const { data } = await httpRequest.delete(`${PATH}/completed/${id}`);
    return data;
};

export const markRead = async () => {
    const { data } = await httpRequest.put(`${PATH}/completed/mark-read`);
    return data;
};
